import React from 'react'
import { Heading, Icon } from 'components'
import parseHtml from 'utils/parseHtml'
import * as Styles from './Card.module.css'
const Card = ({ data: { icon, heading, text } }) => {
  return (
    <div className={Styles.cardWrapper}>
      <div className={Styles.iconWrapper} data-color={icon.color}>
        <Icon className={Styles.icon} name={icon.name} />
      </div>
      <Heading className="text-xl" level="3">
        {parseHtml(heading)}
      </Heading>
      <p>{parseHtml(text)}</p>
    </div>
  )
}

export default Card
